import { onCLS } from 'web-vitals/attribution';
import type { CLSMetricWithAttribution } from 'web-vitals/attribution';
import type { MetricReport } from '../contracts/metricReport';
import { toClsReport } from './mappers';

const onCumulativeLayoutShift = (report: (m: MetricReport) => void): void => {
  onCLS((metric: CLSMetricWithAttribution) => {
    report(toClsReport(metric));
  });
};

export default onCumulativeLayoutShift;
